'use client'

import { ReactNode } from 'react'
import { motion } from 'motion/react'

import type { Variants } from 'motion/react'

//! These are starter shells for the animations to be added to the components on the contact pages. They are not yet a 1:1 of the inspiration.

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
}

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
  },
}

const headingVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
  },
}

const formVariants: Variants = {
  hidden: { opacity: 0, x: 30 },
  visible: {
    opacity: 1,
    x: 0,
  },
}

export const AnimatedContainer = ({ children }: { children: ReactNode }) => {
  return (
    <motion.div initial="hidden" animate="visible" variants={containerVariants}>
      {children}
    </motion.div>
  )
}

export const AnimatedHeading = ({ children }: { children: ReactNode }) => {
  return (
    <motion.h1 variants={headingVariants} transition={{ duration: 0.8, ease: 'easeOut' }}>
      {children}
    </motion.h1>
  )
}

export const AnimatedSubtitle = ({ children }: { children: ReactNode }) => {
  return (
    <motion.div variants={itemVariants} transition={{ duration: 0.6, ease: 'easeOut' }}>
      {children}
    </motion.div>
  )
}

export const AnimatedLayout = ({ children }: { children: ReactNode }) => {
  return <motion.div variants={containerVariants}>{children}</motion.div>
}

export const AnimatedForm = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string | undefined
}) => {
  return (
    <motion.div
      className={className}
      variants={formVariants}
      transition={{ duration: 0.7, ease: 'easeOut', delay: 0.3 }}
    >
      {children}
    </motion.div>
  )
}
